import { render } from "./NodeChat.vue?vue&type=template&id=2e9bbbe6"
import script from "./NodeChat.vue?vue&type=script&lang=js"
export * from "./NodeChat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"NodeChat.vue"]])

export default __exports__